import { render, staticRenderFns } from "./huodongGoods.vue?vue&type=template&id=7344ddaf"
import script from "./huodongGoods.vue?vue&type=script&lang=js"
export * from "./huodongGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports